import {breakPoints, darkModeColors, elementsColors, hiContrastElementsColors, lightModeColors} from '../util';
import type {Config} from 'tailwindcss'


export const elementsPackageTailwindConfigPreset = {
  darkMode: 'class', // or 'media' or 'class'
  content: [],
  variants: {},
  plugins: [
    // @ts-ignore
    function ({addComponents}) {
      addComponents({
        '[data-is-hydrating="true"] *': {
          pointerEvents: 'none',
          userSelect: 'none',
        },
      });
    },
  ],
  theme: {
    extend: {
      screens: {
        ...breakPoints,
      },
      fontFamily: {
        sans: ['"Tenon"', '-apple-system', 'sans-serif'],
      },
      colors: {
        boxBlue: '#499DE7',
        onboardingBlue: '#80adff',
        androidCard: '#242629',
        theme: {
          background: 'rgb(var(--color-background) / <alpha-value>)',
        },
        palette: {
          100: 'rgb(var(--color-palette-100) / <alpha-value>)',
          200: 'rgb(var(--color-palette-200) / <alpha-value>)',
          300: 'rgb(var(--color-palette-300) / <alpha-value>)',
          400: 'rgb(var(--color-palette-400) / <alpha-value>)',
          500: 'rgb(var(--color-palette-500) / <alpha-value>)',
          600: 'rgb(var(--color-palette-600) / <alpha-value>)',
          700: 'rgb(var(--color-palette-700) / <alpha-value>)',
          800: 'rgb(var(--color-palette-800) / <alpha-value>)',
          900: 'rgb(var(--color-palette-900) / <alpha-value>)',
          1000: 'rgb(var(--color-palette-1000) / <alpha-value>)',
          1100: 'rgb(var(--color-palette-1100) / <alpha-value>)',
        },
        lightMode: lightModeColors,
        darkMode: darkModeColors,
        elements: elementsColors,
        hiContrastElements: hiContrastElementsColors,
      },
      boxShadow: {
        base: '0 6px 12px 4px rgba(0, 0, 0, 0.2)',
        classic: '0 6px 12px 4px rgba(0, 0, 0, 0.2), inset 0 1px 0 0 rgba(88, 95, 102, 0.32)',
        lightModeClassic: '0px 6px 12px 4px rgba(0, 0, 0, 0.10)',
        mobileTile: '0 2px 20px 0px rgba(0, 0, 0, 0.5), inset 0 1px 0 0 rgba(255, 255, 255, 0.12)',
        insetCustom: 'inset 0 1px 0 0 rgba(88, 95, 102, 0.3)'
      },
    },
  },
} satisfies Config;
